import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Campaign } from 'src/app/core/models/lead-campaign';
import { FeatureToggleService } from 'src/app/core/toggle/feature-toggle.service';

@Component({
  selector: 'app-lead-offer-card',
  templateUrl: './lead-offer-card.component.html',
  styleUrls: ['./lead-offer-card.component.scss']
})
export class LeadOfferCardComponent implements OnInit {

  @Output() public showModalParticipants = new EventEmitter<boolean>();
  @Output() public showSummaryModal = new EventEmitter<boolean>();

  @Input() public campaign: Campaign;
  @Input() public isLoading: boolean;

  public isEditable: boolean;

  constructor(private toggleService: FeatureToggleService) { }

  ngOnInit() {
    this.checkToggles();
  }

  public associate(): void {
    if (this.campaign.participating) {
      if (this.isEditable) this.showSummaryModal.emit(true);
      return;
    }

    this.showModalParticipants.emit(true);
  }

  public getBttnName(): string {
    if (this.campaign.participating) {
      if (this.isEditable) return 'Resumo';
      return 'Participando';
    }
    return 'Participar';
  }

  private checkToggles() {
    this.isEditable = this.toggleService.isActive('toggle_lopes_lead_subscription_editable');
  }
}